import { toast } from "react-toastify";
import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../endpoints";

const fetchFileData = async (fileType: "ssh" | "config" = "ssh") => {
  const endpoint = `${END_POINTS.DOWNLOAD_SAMPLE_FILE}?file_type=${fileType}`;

  try {
    const response = await axiosInstance.get(endpoint, {
      responseType: "blob",
    });
    if (response) {
      downloadFile(response, fileType);
    }
  } catch (error) {
    toast.error("Error downloading file: ");
  }
};

const downloadFile = (data: any, fileType: "ssh" | "config" = "ssh") => {
  const contentDisposition = data?.headers?.["content-disposition"] || "";
  const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
  const headerName = match?.[1]?.replace(/['"]/g, "");
  const filename =
    headerName || (fileType === "ssh" ? "ssh.csv" : "Cisco_ASA.txt");

  const url = window.URL.createObjectURL(new Blob([data.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const SSHService = {
  submitSSHData: async (sshData: any) => {
    try {
      const isFormData = sshData instanceof FormData;
      const config = isFormData
        ? {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
        : undefined;
      const response = await axiosInstance.post(END_POINTS.API_FIELD, sshData, config);
      return response.data;
    } catch (error) {
      toast.error("Failed to submit SSH data:" + error.message);
      //throw error;
    }
  },
  submitSSHUpload: async (sshData: FormData) => {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent: any) => {
        if (progressEvent.total) {
          //setUploadPercentage(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        }
      },
      onRequest: () => {
        console.log('Request has been sent');
        //setUploadPercentage(0);  // Reset progress when the request is first sent
      }
    };
    try {
      const response = await axiosInstance.post(END_POINTS.SSH_UPLOAD, sshData, config);
      return response.data;
    } catch (error) {
      toast.error("Failed to submit SSH data:");
      throw error;
    }

  },
  fetchFileData
};

export default SSHService;
